export const UPLOAD_INVENTORY_FILE_MODAL_TYPES = {
  buffers: 'buffers',
  quantity: 'quantity',
};
